import { Injectable } from '@angular/core';
import { CubejsConfig } from '@cubejs-client/ngx';
import { map, Observable, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';

@Injectable()
export class AuthenCubeJsService {
  public config$: Observable<CubejsConfig> = this.oktaService.authToken$.pipe(
    take(1),
    map((authToken) => {
      return {
        token: `${environment.dataTokenTypeValueInSession} ${authToken}`,
        options: {
          apiUrl: environment.cubeUrlApi,
        },
      };
    }),
  );

  constructor(private readonly oktaService: AuthService) {}
}
